export const getImageOrientations = (images) =>
  images.map((image) => {
    const aspectRatio = image.width / image.height;

    return aspectRatio > 1 ? 'horizontal' : 'vertical';
  });
